<template>
  <div class="pt-4">
    <h2 class="text-body-1 black--text mb-2">
      Allekirjoitus
    </h2>

    <v-alert
      v-if="(signer.ssn && isSigned(signer.ssn)) || signed"
      color="green darken-1"
      dense
      text
      icon="check"
      border="left"
      prominent
    >
      <v-row align="center">
        <v-col :class="$vuetify.breakpoint.xs ? 'pb-0' : ''" class="grow">
          <b>{{ signer.name }}</b><br>
          {{ signer.ssn }}
        </v-col>
        <v-col :class="$vuetify.breakpoint.xs ? 'pt-0' : ''" class="shrink">
          Allekirjoitettu
        </v-col>
      </v-row>
    </v-alert>

    <v-alert
      v-else
      color="primary"
      text
      dense
      icon="lock"
      border="left"
      prominent
    >
      <v-row align="center">
        <v-col class="grow">
          <b>{{ signer.name }}</b><br>
          {{ signer.email }}
        </v-col>
        <v-col :class="$vuetify.breakpoint.xs ? 'pt-1' : ''" class="shrink">
          <v-btn color="primary" @click="netsLink(indexInSigners, responseIndex)">
            Allekirjoita
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { apiPost } from '../api';

export default {
  name: 'NetsSignature',
  props: {
    signed: {
      type: Boolean,
      default: false,
    },
    createDate: {
      type: String,
      default: '',
    },
    companyId: {
      type: Number,
      default: null,
    },
    form: {
      type: Object,
      default: () => {},
    },
    signatures: {
      type: Array,
      default: () => [],
    },
    responseIndex: {
      type: Number,
      default: 0,
    },
    signers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({}),
  computed: {
    ...mapState({
      currentSigner: state => state.currentSigner,
    }),
    signer() {
      // return this.signers
      //   .find(s => (s.email === this.currentSigner.email));
      return this.currentSigner.participantIndex !== undefined
        && this.currentSigner.participantIndex !== null
        ? this.signers[this.currentSigner.participantIndex] : null;
    },
    indexInSigners() {
      return this.signers.indexOf(this.signer);
    },
    signatureMakers() {
      if (this.responseIndex !== 0 && (this.responseIndex === 1 || this.responseIndex % 2 !== 0)) {
        return this.signers;
      }
      return this.form.offerers;
    },
  },
  methods: {
    isSigned(ssn) {
      return this.signatures.some(s => s.ssn === ssn);
    },
    getSignedName(item) {
      if (this.signatures.length > 0 && this.signatures.find(s => s.ssn === item.ssn)) {
        return this.signatures.find(s => s.ssn === item.ssn).name;
      }
      return item.name;
    },
    async netsLink(index, responseIndex) {
      const state = `${this.$route.params.id}_${this.$route.params.offerId}_${index}_${responseIndex}_${this.$route.params.companyId}_${this.companyId}`;

      const response = await apiPost('nets/get-link', { state });

      window.location.href = response.result;
    },
  },
};
</script>
